exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Term-Review .submit{text-align:center;font-size:29px;padding-bottom:15PX;letter-spacing:0px;color:#171725;opacity:1}.Term-Review .gender-button .MuiButtonBase-root{padding:.25rem}.errorMessageCustom{color:#f44336;font-size:.9rem;text-align:left;font-family:\"Assistant\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400;line-height:1.66;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PolicyReview/TermReview/TermReview.scss
// module id = 7692
// module chunks = 101